import { AppState } from '@reducers/rootReducer';
import type { ReduxAction } from '../../types';
import { selectCurrentLocation } from '@actions/ui';

export type NavBarStatus = 'pinned' | 'hidden' | 'floating';

export interface NavBarState {
  status: NavBarStatus;
  transitioning?: boolean;
  exiting?: NavBarStatus;
  entering?: NavBarStatus;
}

export const selectNavBarState = (state: AppState) => {
  const currentLocation = selectCurrentLocation(state);

  if (currentLocation.pathname === '/tour') {
    return { ...state.ui.navBar, status: 'pinned' };
  }

  return state.ui.navBar;
};

const initialNavBarState = {
  status: 'pinned' as NavBarStatus,
  transitioning: false,
};

export function navBarReducer(
  state: NavBarState = initialNavBarState,
  { type, payload }: ReduxAction,
) {
  switch (type) {
    case 'LOAD_LOCAL_STORE_SUCCEEDED':
      const status = payload.get('nav_bar_status') || 'pinned';
      return { ...state, status };

    case 'NAV_BAR_START_TRANSITION':
      return {
        ...state,
        status: payload.status,
        exiting: state.status,
        entering: payload.status,
        transitioning: true,
      };

    case 'NAV_BAR_FINISHED_TRANSITION':
      return {
        ...state,
        exiting: undefined,
        entering: undefined,
        transitioning: false,
      };

    default:
      return state;
  }
}
